<template>
  <transition name="slide-fade">
    <div class="zdh-compare-cart" v-if="isShow">
      <span class="zdh-compare-cart-header">{{ $t('ingredientClient.comparison') }}</span>
      <span class="zdh-compare-number">{{ count }}</span>
      <router-link :to="link" class="zdh-compare-btn">{{ $t('ingredientClient.view') }}</router-link>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('compare', [
      'type',
      'isShow',
      'brand',
      'formulation',
      'goods',
      'inci'
    ]),
    count () {
      return this[this.type] || 0
    },
    link () {
      if (this.type === 'goods') {
        return '/dlite3x/my-comparison/product-comparison'
      } else if (this.type === 'inci') {
        return '/dlite3x/my-comparison/inci-comparison'
      } else if (this.type === 'formulation') {
        return '/dlite3x/my-comparison/formulation-comparison'
      } else if (this.type === 'brand') {
        return '/dlite3x/my-comparison/brand-comparison'
      }
    }
  },
  watch: {
    '$route' () {
      // 关闭计数
      this.setCountShow(false)
    }
  },
  methods: {
    ...mapActions('compare', [
      'setCountShow'
    ])
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

.zdh-compare-cart
  position fixed
  width 106px
  height 127px
  box-sizing border-box
  border  1px solid #ffffff
  display flex
  flex-flow column nowrap
  text-align center
  justify-content space-between
  background #ffffff
  z-index: 10;
  top: 40%;
  right: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.2);
  transition opacity .2s linear
  .zdh-compare-cart-header
    font2()
    font-size 12px
    background $themeColor3
    color #fff
    line-height 40px
  .zdh-compare-number
    font1()
    font-size 28px
    color $themeColor3
    flex-grow: 1;
    padding-top: 10px;
  .zdh-compare-btn
    line-height 40px
    font2()
    font-size 12px
    color $themeColor3
    text-decoration none
    cursor pointer
    transition all .3s linear
    &:hover
      background $themeColor3
      color #ffffff

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/compare/Compare.vue